<app-action-modal
  #actionModal
  [disabled]="submitted"
  [submitDisabled]="!confirmed.value || effectiveDate.invalid"
  [showHeader]="true"
  submitButtonClass="lty-btn-primary"
  customModalClass="cancellation-finalize-modal"
  (submitted)="confirm()"
>
  <span class="cancellation-finalize-modal__title" mainTitle i18n
    >Finaliser la résiliation</span
  >
  <div body>
    <div class="form-check cancellation-finalize-modal__check">
      <input
        class="form-check-input"
        type="checkbox"
        id="cancellation-finalize-confirmed"
        [formControl]="confirmed"
      />
      <label
        class="form-check-label"
        for="cancellation-finalize-confirmed"
        i18n
      >
        L'assureur a confirmé la résiliation
      </label>
    </div>
    <div class="lty-form cancellation-finalize-modal__date">
      <div class="form-group">
        <label for="cancellation-finalize-effective-date" i18n
          >Date de résiliation effective</label
        >
        <input
          class="form-control"
          type="date"
          id="cancellation-finalize-effective-date"
          [formControl]="effectiveDate"
        />
      </div>
    </div>
  </div>
  <ng-container submitButtonLabel i18n>Confirmer</ng-container>
</app-action-modal>
